// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f0c181 {
  color: var(--base-text-meta);
  display: flex;
}
.d8eaa4 {
  color: var(--base-validation-error);
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Fields/BaseInput/components/BaseInputMetaText/BaseInputMetaText.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,mCAAmC;AACrC","sourcesContent":[".f0c181 {\n  color: var(--base-text-meta);\n  display: flex;\n}\n.d8eaa4 {\n  color: var(--base-validation-error);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
